export default __webpack_public_path__ + "static/media/event-1.c947b89b.jpg";